import React, { Component } from 'react';
import { connect } from "react-redux";
import { Field, reduxForm, initialize } from 'redux-form';

import { logout, uploadPicture, updateProfile, removeMyHappiness } from '../../redux/actions';

import { ShortField } from '../atoms/formElements/formElements';
import ImageField from '../atoms/formElements/formImageField';
import Tag from '../atoms/tag/tag'
import Button from '../atoms/button/button';
import Tabs from '../organisms/tabs/tabs';
import SideModal from '../molecules/modal/sideModal';
import ProfilePic from '../atoms/profilePic/profilePic';

class Profile extends Component {
  render() {
    const { user, state, handleSubmit } = this.props
    return (
      <SideModal active={state ? 'active' : null } screen='profile' >
        <div className='powerbtn mdi mdi-power' onClick={() => this.props.logout()} />
        <div className='avatarWrapper'>
          <input className="avatarEmpty" type="file" accept="image/*" capture onChange={(e) => this.props.uploadPicture(e.target.files[0])} />
          <div className="empty mdi mdi-camera"></div>
          <ProfilePic size='big' employee={user} />
          <Tag label={`${user.points ? user.points : 0} high fives received`} />
        </div>
        <h2>{user.email}</h2>
        <p className="center">Did you know that happy employees are up to 20% more productive than unhappy employees? And what’s a good way to help your co-workers get there? Give regocnition for good work! Every time you get a compliment from a work buddy, you get one cubic! The person with the most cubics can choose where to spend the company cubics! </p>
        {user.demo ? <Button label='Remove demo data' disabled='false' onClick={()=> this.props.removeMyHappiness()} /> : null }
      </SideModal>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.general.user,
    initialValues: state.general.user,
    state: state.overlays.profile
  };
}

export default connect(mapStateToProps, { logout, uploadPicture, updateProfile, removeMyHappiness })(Profile);
